import { toastActions } from "pickups-ui-library";
import { call, put, takeLatest } from "redux-saga/effects";
import * as AuthApi from "../../api/auth";
import * as AuthActions from "./actions";
import * as constants from "./constants";

function* loginUser(action) {
  try {
    const response = yield call(AuthApi.loginUser, action.data);
    const userData = response.data.data;
    const user = Array.isArray(userData) ? userData[0] : userData;
    yield AuthApi.storeUser(user);
    AuthApi.clearGuestToken();
    yield put(AuthActions.loginUserSuccess(user));
  } catch (e) {
    toastActions.showToast({
      message: e.message,
      type: "error",
    });
    yield put({ type: constants.LOGIN_USER_FAILED, message: e.message });
  }
}

function* logoutUser() {
  try {
    yield call(AuthApi.logout);
    yield put({ type: constants.LOGOUT_USER_SUCCESS });
  } catch (e) {
    yield put({ type: constants.LOGOUT_USER_FAILED, message: e.message });
  }
}

function* checkAuthToken() {
  // Skip API call if no stored session — prevents 401 loop on fresh/logged-out visits
  if (!AuthApi.loggedIn()) {
    yield put({ type: constants.CHECK_TOKEN_FAILED });
    return;
  }

  try {
    const response = yield call(AuthApi.authToken);
    const userData = response.data.data;
    const user = Array.isArray(userData) ? userData[0] : userData;
    yield AuthApi.storeUser(user);
    yield put({
      type: constants.CHECK_TOKEN_SUCCESS,
      data: user,
    });
  } catch (e) {
    // Token invalid/expired and refresh failed — clear session
    localStorage.removeItem("pu.user");
    yield put({ type: constants.CHECK_TOKEN_FAILED, message: e.message });
  }
}

export default function* authSaga() {
  yield takeLatest(constants.LOGIN_USER, loginUser);
  yield takeLatest(constants.LOGOUT_USER, logoutUser);
  yield takeLatest(constants.CHECK_TOKEN, checkAuthToken);
}
